import React from 'react'
import { Button } from '@/shared/ui/Button'
import { Input } from '@/shared/ui/Input'
import { Slider } from '@/shared/ui/Slider'
import { Select } from '@/shared/ui/Select'
import { useOportunidadesFiltersStore } from '../stores/oportunidadesFiltersStore'

const TF_OPTIONS: Array<{ key: any; label: string }> = [
  { key: 'all', label: 'Todos' },
  { key: '1h', label: '1h' },
  { key: '4h', label: '4h' },
  { key: '12h', label: '12h' },
  { key: '1D', label: '1D' },
  { key: '1W', label: '1W' },
  { key: '1M', label: '1M' },
]

export default function OportunidadesFilterControls({ showHeader }: { showHeader?: boolean }) {
  const f = useOportunidadesFiltersStore()
  return (
    <div className="space-y-3">
      {showHeader && <div className="text-sm font-medium">Filtros</div>}
      <div className="grid grid-cols-1 gap-3">
        {/* Busca (topo, largura total do drawer) */}
        <div className="flex items-center">
          <Input
            placeholder="Buscar símbolo..."
            className="h-9 w-full text-sm"
            value={f.search}
            onChange={(e) => f.setSearch(e.target.value)}
          />
        </div>
        {/* Ordenação */}
        <div className="flex items-center gap-2">
          <span className="whitespace-nowrap text-xs text-foreground/70">Ordenar por</span>
          <Select className="h-9" value={f.sort} onChange={(e) => f.setSort(e.target.value as any)}>
            <option value="date">Data (mais recentes)</option>
            <option value="relevance">Relevância</option>
            <option value="symbol">Símbolo (A–Z)</option>
          </Select>
        </div>
        {/* Objetivo (seleção em verde limão) */}
        <div className="flex flex-wrap items-center gap-1">
          <span className="mr-2 whitespace-nowrap text-xs text-foreground/70">Objetivo</span>
          <Button
            variant="outline"
            className={`h-8 px-2 text-xs ${f.objective === 'all' ? 'border-lime-400 text-lime-400 bg-lime-400/10' : ''}`}
            onClick={() => f.setObjective('all')}
          >
            Todos
          </Button>
          <Button
            variant="outline"
            className={`h-8 px-2 text-xs ${f.objective === 'long' ? 'border-lime-400 text-lime-400 bg-lime-400/10' : ''}`}
            onClick={() => f.setObjective('long')}
          >
            bullish
          </Button>
          <Button
            variant="outline"
            className={`h-8 px-2 text-xs ${f.objective === 'short' ? 'border-lime-400 text-lime-400 bg-lime-400/10' : ''}`}
            onClick={() => f.setObjective('short')}
          >
            bearish
          </Button>
        </div>
        {/* Timeframe (multi-seleção) */}
        <div className="flex flex-wrap items-center gap-1">
          <span className="mr-2 whitespace-nowrap text-xs text-foreground/70">TF Alvo</span>
          {TF_OPTIONS.map((o) => {
            const selected = (f.timeframes || []).includes(o.key)
            const selCls = selected ? 'border-lime-400 text-lime-400 bg-lime-400/10' : ''
            return (
              <Button
                key={o.key}
                variant="outline"
                className={`h-8 px-2 text-xs ${selCls}`}
                onClick={() => f.toggleTimeframe(o.key)}
              >
                {o.label}
              </Button>
            )
          })}
        </div>
        {/* Zona de entrada – imediatamente abaixo de TF Alvo */}
        <div className="flex flex-wrap items-center gap-1">
          <span className="mr-2 whitespace-nowrap text-xs text-foreground/70">Zona de entrada</span>
          <Button
            variant="outline"
            className={`h-8 px-2 text-xs ${f.entryZone === 'all' ? 'border-lime-400 text-lime-400 bg-lime-400/10' : ''}`}
            onClick={() => f.setEntryZone('all')}
          >
            Todas
          </Button>
          <Button
            variant="outline"
            className={`h-8 px-2 text-xs ${f.entryZone === 'inside' ? 'border-lime-400 text-lime-400 bg-lime-400/10' : ''}`}
            onClick={() => f.setEntryZone('inside')}
          >
            Dentro
          </Button>
          <Button
            variant="outline"
            className={`h-8 px-2 text-xs ${f.entryZone === 'outside' ? 'border-lime-400 text-lime-400 bg-lime-400/10' : ''}`}
            onClick={() => f.setEntryZone('outside')}
          >
            Fora
          </Button>
        </div>
        {/* Mínimo % */}
        <div className="flex flex-col gap-1">
          <div className="flex items-center justify-between">
            <span className="text-xs text-foreground/70">Mín. %</span>
            <span className="text-xs font-medium">{f.minPercent}%</span>
          </div>
          <Slider
            min={0}
            max={100}
            step={5}
            value={f.minPercent}
            onChange={(e: any) => f.setMinPercent(Number(e?.target?.value || 0))}
          />
        </div>
      </div>
      <div className="mt-1 flex items-center justify-end">
        <Button variant="ghost" className="h-8 px-2 text-xs" onClick={() => f.reset()}>
          Limpar filtros
        </Button>
      </div>
    </div>
  )
}
